import reportError from 'airship/modules/report-error'
const debug = require('./debug')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LoggableArg = any

export function log(message: string, ...optionalParams: LoggableArg[]): void {
  try {
    if (!debug()) {
      return
    }
    // eslint-disable-next-line no-console
    console.debug(message, ...optionalParams)
  } catch (err) {
    reportError(err)
  }
}
